import { Hamburger } from './Header.components.styles';
import type { MenuProps } from './Header.components';

const HeaderMenu = ({ children, onClick, open }: MenuProps) => (
  <Hamburger.Menu
    aria-controls="menu-list"
    aria-expanded={open}
    aria-haspopup="true"
    aria-label="abrir menu"
    data-testid="hamburger"
    onClick={onClick}
  >
    <Hamburger.Icon data-isopen={open} preserveAspectRatio="xMidYMid meet" viewBox="0 0 25 24">
      <title id="menu-title">Hamburger Menu</title>
      <desc>
        Três linhas distribuidas horizontalmente que visualmente formam um aspecto similar a um
        hamburguer para representar o menu.
      </desc>
      <path d="M3.5 18H21.5V16H3.5V18ZM3.5 13H21.5V11H3.5V13ZM3.5 6V8H21.5V6H3.5Z" />
    </Hamburger.Icon>

    {children}
  </Hamburger.Menu>
);

export default HeaderMenu;
